export const employeeConductDialogDisplayNameOptions = [
	{ id: '1', value: 'Coaching', label: 'Coaching' },
	{ id: '2', value: 'Discipline', label: 'Discipline' },
	{ id: '3', value: 'Corrective Action', label: 'Corrective Action' }
];

export const Privs = {
	EMPLOYEE_VIEW_SETTINGS: 1127,
	EMPLOYEE_EDIT_SETTINGS: 1128,
	EXCLUDE_SAME_EMPLOYEENUMBER_FEATURE: 456
};

export const EMPLOYEE_SETTINGS_FEATURE_FLAG = 'HRSettingsUI_Enabled';
export const EMPLOYEE_NUMBER_SETTINGS_FEATURE_FLAG = 'EmployeeNumberSettings_Enabled';
export const GLOBAL_CLIENT_SWITCHER_FEATURE_FLAG = 'Enable_Global_Company_Switcher_HR';
export const ENABLE_PROCESS_FLOW = 'Enable_Process_Flow';
export const ONBOARDING_PREVENT_DUPLICATE_FEATURE_FLAG = 'Onboarding_Prevent_Duplicate';

export const clearBanner = {
	showBanner: false,
	text: '',
	status: null
};
